module.exports = __webpack_public_path__ + "static/matthias-b3333936a01405c365ecd5022708c6d8.jpg";